import getIn from 'transmute/getIn';
import { messageTypeKeyPath } from '../constants/keyPaths';
import { FAILED_TO_PUBLISH } from 'conversations-message-history/unpublished-messages/constants/messageTypes';
export const isFailedToPublish = publishingRecord => getIn(messageTypeKeyPath, publishingRecord) === FAILED_TO_PUBLISH;